import PatientsInProject from './PatientsInProject';

export default PatientsInProject;
